import { render, staticRenderFns } from "./AmateurResult.vue?vue&type=template&id=8c27a670&"
import script from "./AmateurResult.vue?vue&type=script&lang=js&"
export * from "./AmateurResult.vue?vue&type=script&lang=js&"
import style0 from "./AmateurResult.vue?vue&type=style&index=0&id=8c27a670&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports